module.exports = __webpack_public_path__ + "static/media/bored-weary.816d8cc7.png";